import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, CustomSoftIcon, SoftwareProIcon, SoftwareMainIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component
import HtmlParser from 'react-html-parser';


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                Elevate your business with TekRevol's cutting-edge{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development services
                </Link> {' '}
                By crafting a tailored user experience through an advanced user interface, you can set yourself apart in the market and start dominating your industry. Currently, our team is supporting diverse industries with our robust applications.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                Through our{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iOS app development services,
                </Link> {' '}
                companies can effectively produce high-performing native iOS apps by harnessing state-of-the-art iOS development tools and programming languages like Swift, Objective C, XCode, and others. Our Washington DC based iOS app services ignite your app project, from consumer apps to intricate on-demand solutions.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                Launch a game with fresh content and monetize through ads, sponsored content, and premium subscriptions. Work with an experienced{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game app development company
                </Link> {' '}
                in integrating AR, VR, Blockchain, and NFTs in gaming environments. With our unmatched services, your game can be the next big thing in this huge industry.
            </>
        ),
    },
    {
        icon: CustomSoftIcon,
        title: 'Custom Software Development',
        description: (
            <>
                With our{' '}
                <Link to="/custom-software-development" rel="noopener" aria-label="TekRevol">
                    custom software development services
                </Link> {' '}
                ,we facilitate organizations with bespoke solutions specifically designed to address their unique requirements. These tailored software solutions not only enable seamless integration with existing systems but also improve data security, ensuring the protection of sensitive information.
            </>
        ),
    },
    {
        icon: SoftwareProIcon,
        title: 'Software Product Development',
        description: 'We offer software product development services based on the creation of tailored solutions to address a broader audience and solve a unique problem. Our product development relies on expertise in various domains, including product strategy, user experience design, coding, rigorous quality assurance, and seamless deployment.',
    },
    {
        icon: SoftwareMainIcon,
        title: 'Software Support and Maintenance',
        description: 'Software support and maintenance services are the primary sources in guaranteeing the optimal performance of software applications as time progresses. These services are based on proactive monitoring, management, and issue resolution to enhance user experience. It involves regular updates to stay in sync with evolving technological advancements.',
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2> TekRevol’s Custom App and Software Development Services in Washington DC</h2>
                        <p className="impro_para">We go beyond the conventional identity of a software development company in Washington DC, positioning ourselves as your innovation partner. Our highly skilled team excels at transforming your unique vision into reality. To us, your app signifies more than just another project; it represents a journey toward fostering your business's success in the digital landscape.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;